import template from './menu-project-changer.pug';
import { createPopper } from '@popperjs/core';

export const MenuProjectChanger = {
  template,
  bindings: {
  },
  controller: class MenuProjectChanger {
    constructor($element, $state, $async, $log, $sessionStorage, Project, Settings) {
      'ngInject';

      this.$element = $element;
      this.$state = $state;
      this.$log = $log;
      this.$sessionStorage = $sessionStorage;
      this.Project = Project;
      this.Settings = Settings;

      this.popperShow = false;
      this.currentProject = '';
      this.projects = [];

      this.getProjects = $async(this.getProjects.bind(this));
      this.changeProject = $async(this.changeProject.bind(this));
      this.newGroup = $async(this.newGroup.bind(this));
    }

    $onInit() {
      this.getProjects();
    }

    async openPopper(event) {
      this.popperShow = !this.popperShow;

      if (this.popperShow) {
        this.getProjects();
        const popperEl = this.$element.find('#menu-project-dropdown')[0];
        const options = {
          placement: 'bottom-end',
          offset: [0, 0],
          strategy: 'fixed'
        };

        this.popper = createPopper(event.currentTarget, popperEl, options);
      } else {
        this.closePopper();
      }
    }

    closePopper() {
      this.popperShow = false;
      this.popper.destroy();
    }

    async changeProject(project) {
      try {
        const resp = await this.Settings.update({ module: 'project', key: 'default', value: project.id });
        if (resp) {
          this.$sessionStorage.project = project.id;
          this.$state.reload();
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    getInitials(value) {
      const initials = value ? value.toInitials() : '';
      return initials;
    }

    imageStyle(project) {
      if (!project) return;

      return { 'background-color': project.color };
    }

    async getProjects() {
      try {
        this.projects = await this.Project.getGroups();
        console.log('projects',this.projects);
        this.currentProject = angular.copy(this.projects.find(item => item.id == this.Project.currentProjectId()));
        if (this.currentProject == null) {
          this.currentProject = angular.copy(this.projects[0]);
          this.$sessionStorage.project = this.currentProject.id;
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    async newGroup() {
      try {
        const group = await this.Project.groupModal();
        if (group) {
          this.changeProject(group);
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    goToSettings() {
      this.$state.go('main.settings.projects');
    }

  }
};
